import {
  ADD_PROJECT,
  ADD_PROJECT_MONTH_STATISTIC,
  EDIT_PROJECT,
  PROJECTS_DATE_CHANGED,
  PROJECT_SEARCH,
  REMOVE_PROJECT,
} from './types';
import * as API from '../../api';
import type { Action, Project, ProjectRequest } from '../../types';

export const addProject = (project: ProjectRequest): Action => ({
  type: ADD_PROJECT,
  payload: API.addProject(project),
});

export const editProject = (project: Project): Action => ({
  type: EDIT_PROJECT,
  payload: API.editProject(project),
});

export const removeProject = (projectId: number): Action => ({
  type: REMOVE_PROJECT,
  payload: API.removeProject(projectId),
});

export const projectSearch = (year: number, month: number): Action => ({
  type: PROJECT_SEARCH,
  payload: API.projectSearch(year, month),
});

export const datesChanged = (year: number, month: number): Action => ({
  type: PROJECTS_DATE_CHANGED,
  payload: { year, month },
});

export const getProjectMonthStatistic = (year: number, month: number, projectId: number): Action => ({
  type: ADD_PROJECT_MONTH_STATISTIC,
  payload: API.getProjectMonthStatistic(year, month, projectId),
});
